var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticStyle: {
      "border-top-right-radius": "0px",
      "border-bottom-right-radius": "0px",
      "border-right": "0px"
    },
    attrs: {
      label: "Search Filters",
      items: _vm.availableFilters,
      "item-text": "name",
      "item-value": "key",
      "background-color": "input",
      "menu-props": {
        value: _vm.selectMenu,
        offsetY: true,
        maxHeight: "800",
        maxWidth: "900",
        closeOnContentClick: false,
        closeOnClick: true,
        openOnClick: true,
        allowOverflow: true
      },
      disabled: _vm.disabled,
      multiple: "",
      outlined: "",
      "hide-details": "",
      "small-chips": "",
      dense: ""
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function(ref) {
          var attrs = ref.attrs
          var item = ref.item
          return [
            item.key === "ad_group_party_ids" &&
            _vm.params.ad_group_party_ids.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s("" + item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedAdGroups, function(group, index) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.selectedAdGroups.length) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : item.key === "limit_ad_groups" && _vm.params.limit_ad_groups
              ? [
                  _c(
                    "v-chip",
                    {
                      staticStyle: { "max-width": "90%" },
                      attrs: { color: "primary", dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" 'Limit to Selected Ad Groups' ")
                      ]),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    1
                  )
                ]
              : item.key === "promo_category_ids" &&
                _vm.params.promo_category_ids.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s("" + item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedCategories, function(group, index) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.selectedCategories.length) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : item.key === "vendor_party_ids" &&
                _vm.params.vendor_party_ids.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s("" + item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedVendors, function(group, index) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.selectedVendors.length) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : item.key === "subvendor_party_ids" &&
                _vm.params.subvendor_party_ids.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s("" + item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedSubvendors, function(group, index) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.selectedSubvendors.length) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : item.key === "store_party_ids" &&
                _vm.params.store_party_ids.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s(item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedStores, function(group, index) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.selectedStores.length) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : item.key === "category_manager_id" &&
                _vm.params.category_manager_id.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s("" + item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedCategoryManager, function(
                        group,
                        index
                      ) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.selectedCategoryManager.length
                                      ) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : item.key === "dc_party_names" &&
                _vm.params.dc_party_names.length > 0
              ? [
                  _c(
                    "v-chip",
                    {
                      style:
                        item.length > 1 ? "max-width: 70%" : "max-width: 90%",
                      attrs: { color: item.color, dark: "", small: "" }
                    },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(" " + _vm._s("" + item.name) + " ")
                      ]),
                      _vm._l(_vm.selectedDistributionCenters, function(
                        group,
                        index
                      ) {
                        return _c(
                          "span",
                          { key: group.id },
                          [
                            index === 1
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.selectedDistributionCenters.length
                                      ) +
                                      ") "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v(" $delete ")]
                      )
                    ],
                    2
                  )
                ]
              : _c(
                  "v-chip",
                  _vm._b(
                    {
                      attrs: {
                        color: item.color || null,
                        dark: Boolean(item.color),
                        small: ""
                      }
                    },
                    "v-chip",
                    attrs,
                    false
                  ),
                  [
                    _vm._v(" " + _vm._s(_vm.getFilterText(item)) + " "),
                    _c(
                      "v-icon",
                      {
                        attrs: { small: "", right: "" },
                        on: {
                          click: function($event) {
                            return _vm.removeFilter(
                              item.key,
                              item.type === "boolean" ? false : true
                            )
                          }
                        }
                      },
                      [_vm._v(" $delete ")]
                    )
                  ],
                  1
                )
          ]
        }
      },
      {
        key: "item",
        fn: function(ref) {
          var item = ref.item
          var on = ref.on
          var attrs = ref.attrs
          return [
            _c(
              "v-list-item",
              { style: item.custom && { display: "none" } },
              [
                _c(
                  "v-list-item-action",
                  [
                    _c(
                      "v-simple-checkbox",
                      _vm._g(
                        {
                          attrs: {
                            color: "primary",
                            disabled: _vm.isCheckboxDisabled(item),
                            ripple: false
                          },
                          model: {
                            value: attrs.inputValue,
                            callback: function($$v) {
                              _vm.$set(attrs, "inputValue", $$v)
                            },
                            expression: "attrs.inputValue"
                          }
                        },
                        _vm.isCheckboxDisabled(item)
                          ? null
                          : item.key === "ad_group_party_ids"
                          ? Object.assign({}, on, {
                              click: function(e) {
                                return _vm.handleAdGroupCheckboxChange(
                                  e,
                                  on.click
                                )
                              }
                            })
                          : on
                      )
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item-content",
                  { staticStyle: { overflow: "visible" } },
                  [
                    item.key === "promo_category_ids"
                      ? _c("v-autocomplete", {
                          attrs: {
                            label: item.name,
                            items: _vm.sortedCategories,
                            "item-text": "name",
                            "item-value": "id",
                            "item-color": "action",
                            "hide-details": "",
                            multiple: "",
                            "small-chips": "",
                            "deletable-chips": "",
                            clearable: "",
                            outlined: "",
                            dense: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleChangedArray($event, item.key)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.search($event)
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item",
                                fn: function(ref) {
                                  var item = ref.item
                                  var ref_attrs = ref.attrs
                                  var inputValue = ref_attrs.inputValue
                                  var disabled = ref_attrs.disabled
                                  var ripple = ref_attrs.ripple
                                  return [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100%" } },
                                      [
                                        [
                                          _c(
                                            "v-list-item",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { disabled: disabled }
                                            },
                                            [
                                              _c(
                                                "v-list-item-action",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      color: "action",
                                                      "input-value": inputValue,
                                                      disabled: disabled,
                                                      ripple: ripple
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.name) +
                                                        " "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          (item.id === "exclude-amap" &&
                                            !_vm.includeExcludeEba) ||
                                          item.id === "exclude-eba"
                                            ? _c("v-divider")
                                            : _vm._e()
                                        ]
                                      ],
                                      2
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.params.promo_category_ids,
                            callback: function($$v) {
                              _vm.$set(_vm.params, "promo_category_ids", $$v)
                            },
                            expression: "params.promo_category_ids"
                          }
                        })
                      : item.key === "category_manager_id"
                      ? _c("v-autocomplete", {
                          attrs: {
                            label: item.name,
                            items: _vm.categoryManagers,
                            "item-text": "name",
                            "item-value": "id",
                            "item-color": "action",
                            "hide-details": "",
                            multiple: "",
                            "small-chips": "",
                            "deletable-chips": "",
                            clearable: "",
                            outlined: "",
                            dense: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleChangedArray($event, item.key)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.search($event)
                            }
                          },
                          model: {
                            value: _vm.params.category_manager_id,
                            callback: function($$v) {
                              _vm.$set(_vm.params, "category_manager_id", $$v)
                            },
                            expression: "params.category_manager_id"
                          }
                        })
                      : item.key === "ad_group_party_ids"
                      ? _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols:
                                    _vm.$auth.tenant === "alliance-retail-group"
                                      ? 6
                                      : 12
                                }
                              },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    label: item.name,
                                    items: _vm.userAdGroups,
                                    "item-text": "name",
                                    "item-value": "id",
                                    "item-color": "action",
                                    "hide-details": "",
                                    multiple: "",
                                    "small-chips": "",
                                    "deletable-chips": "",
                                    clearable: "",
                                    outlined: "",
                                    dense: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleChangedArray(
                                        $event,
                                        item.key
                                      )
                                    },
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.params.ad_group_party_ids,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.params,
                                        "ad_group_party_ids",
                                        $$v
                                      )
                                    },
                                    expression: "params.ad_group_party_ids"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.$auth.tenant === "alliance-retail-group"
                              ? _c(
                                  "v-col",
                                  {
                                    attrs: { "align-self": "center", cols: "6" }
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "pa-0 ma-0",
                                      attrs: {
                                        label: "Limit to Selected Ad Groups",
                                        dense: "",
                                        disabled:
                                          _vm.params.ad_group_party_ids
                                            .length === 0 ||
                                          _vm.params.ad_group_party_ids ===
                                            null,
                                        "hide-details": "",
                                        color: "primary"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleLimitSelect(
                                            $event,
                                            "limit_ad_groups"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.params.limit_ad_groups,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.params,
                                            "limit_ad_groups",
                                            $$v
                                          )
                                        },
                                        expression: "params.limit_ad_groups"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : item.key === "dc_party_names"
                      ? _c("v-autocomplete", {
                          attrs: {
                            label: item.name,
                            items: _vm.distributionCenters,
                            "item-text": "name",
                            "item-value": "name",
                            "item-color": "action",
                            "hide-details": "",
                            multiple: "",
                            "small-chips": "",
                            "deletable-chips": "",
                            clearable: "",
                            outlined: "",
                            dense: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleChangedArray($event, item.key)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.search($event)
                            }
                          },
                          model: {
                            value: _vm.params.dc_party_names,
                            callback: function($$v) {
                              _vm.$set(_vm.params, "dc_party_names", $$v)
                            },
                            expression: "params.dc_party_names"
                          }
                        })
                      : item.key === "created_on"
                      ? _c(
                          "div",
                          {
                            staticStyle: { position: "relative" },
                            attrs: { id: "created-on-date-menu" }
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "background-color": "white",
                                "item-color": "action",
                                clearable: "",
                                dense: "",
                                "hide-details": "",
                                label: "Created On",
                                outlined: "",
                                readonly: "",
                                "prepend-inner-icon": "mdi-calendar",
                                value: _vm.dateFormatted(_vm.params.created_on)
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.removeFilter(item.key, true)
                                },
                                click: function($event) {
                                  _vm.showCreatedOnMenu = !_vm.showCreatedOnMenu
                                },
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.search($event)
                                }
                              }
                            }),
                            _vm.showCreatedOnMenu
                              ? _c(
                                  "v-card",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "40px",
                                      "z-index": "11"
                                    }
                                  },
                                  [
                                    _c("v-date-picker", {
                                      attrs: {
                                        "show-current": false,
                                        color: "action",
                                        "no-title": ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleChangedDate(item)
                                        }
                                      },
                                      model: {
                                        value: _vm.params.created_on,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.params,
                                            "created_on",
                                            $$v
                                          )
                                        },
                                        expression: "params.created_on"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : item.key === "ad_date"
                      ? _c(
                          "div",
                          {
                            staticStyle: { position: "relative" },
                            attrs: { id: "ad-date-menu" }
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "background-color": "white",
                                clearable: "",
                                dense: "",
                                "hide-details": "",
                                label: "Ad Date",
                                outlined: "",
                                readonly: "",
                                "prepend-inner-icon": "mdi-calendar",
                                value: _vm.dateFormatted(_vm.params.ad_date)
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.removeFilter(item.key, true)
                                },
                                click: function($event) {
                                  _vm.showAdDateMenu = !_vm.showAdDateMenu
                                },
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.search($event)
                                }
                              }
                            }),
                            _vm.showAdDateMenu
                              ? _c(
                                  "v-card",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "40px",
                                      "z-index": "11"
                                    }
                                  },
                                  [
                                    _c("v-date-picker", {
                                      attrs: {
                                        "show-current": false,
                                        color: "action",
                                        "no-title": ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleChangedDate(item)
                                        }
                                      },
                                      model: {
                                        value: _vm.params.ad_date,
                                        callback: function($$v) {
                                          _vm.$set(_vm.params, "ad_date", $$v)
                                        },
                                        expression: "params.ad_date"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : item.key === "billing_week_start"
                      ? _c(
                          "div",
                          {
                            staticStyle: { position: "relative" },
                            attrs: { id: "billing-week-menu" }
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "background-color": "white",
                                clearable: "",
                                dense: "",
                                "hide-details": "",
                                label: "Billing Week",
                                outlined: "",
                                readonly: "",
                                "prepend-inner-icon": "mdi-calendar",
                                value: _vm.dateFormatted(
                                  _vm.params.billing_week_start
                                )
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.removeFilter(item.key, true)
                                },
                                click: function($event) {
                                  _vm.showBillingWeekMenu = !_vm.showBillingWeekMenu
                                },
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.search($event)
                                }
                              }
                            }),
                            _vm.showBillingWeekMenu
                              ? _c(
                                  "v-card",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "40px",
                                      "z-index": "11"
                                    }
                                  },
                                  [
                                    _c("v-date-picker", {
                                      attrs: {
                                        "show-current": false,
                                        color: "action",
                                        "no-title": ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleChangedDate(item)
                                        }
                                      },
                                      model: {
                                        value: _vm.params.billing_week_start,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.params,
                                            "billing_week_start",
                                            $$v
                                          )
                                        },
                                        expression: "params.billing_week_start"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : item.key === "offer_dates"
                      ? _c(
                          "div",
                          {
                            staticStyle: { position: "relative" },
                            attrs: { id: "offer-date-menu" }
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "background-color": "white",
                                clearable: "",
                                dense: "",
                                "hide-details": "",
                                label: "Perishable Offer Dates",
                                outlined: "",
                                readonly: "",
                                "prepend-inner-icon": "mdi-calendar",
                                value: _vm.formattedDates
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.removeFilter(item.key, true)
                                },
                                click: function($event) {
                                  _vm.showOfferDateMenu = !_vm.showOfferDateMenu
                                },
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.search($event)
                                }
                              }
                            }),
                            _vm.showOfferDateMenu
                              ? _c(
                                  "v-card",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "40px",
                                      "z-index": "11"
                                    }
                                  },
                                  [
                                    _c("v-date-picker", {
                                      attrs: {
                                        "show-current": false,
                                        min: _vm.offerDatesArePresent
                                          ? _vm.params.offer_dates[0]
                                          : null,
                                        color: "action",
                                        range: "",
                                        "no-title": ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleChangedDate(item)
                                        }
                                      },
                                      model: {
                                        value: _vm.params.offer_dates,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.params,
                                            "offer_dates",
                                            $$v
                                          )
                                        },
                                        expression: "params.offer_dates"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : item.key === "vendor_party_ids"
                      ? _c("VendorSelect", {
                          attrs: { selectedVendors: _vm.selectedVendors },
                          on: {
                            "update:selectedVendors": function($event) {
                              _vm.selectedVendors = $event
                            },
                            "update:selected-vendors": function($event) {
                              _vm.selectedVendors = $event
                            }
                          }
                        })
                      : item.key === "subvendor_party_ids"
                      ? _c("SubvendorSelect", {
                          attrs: { selectedSubvendors: _vm.selectedSubvendors },
                          on: {
                            "update:selectedSubvendors": function($event) {
                              _vm.selectedSubvendors = $event
                            },
                            "update:selected-subvendors": function($event) {
                              _vm.selectedSubvendors = $event
                            }
                          }
                        })
                      : item.key === "store_party_ids"
                      ? _c("StoreSelect", {
                          attrs: { selectedStores: _vm.selectedStores },
                          on: {
                            "update:selectedStores": function($event) {
                              _vm.selectedStores = $event
                            },
                            "update:selected-stores": function($event) {
                              _vm.selectedStores = $event
                            }
                          }
                        })
                      : item.type === "boolean"
                      ? _c(
                          "div",
                          { staticClass: "ma-0 pa-0" },
                          [
                            _c("v-switch", {
                              staticClass: "pa-0 ma-0",
                              attrs: {
                                label: item.name,
                                dense: "",
                                "hide-details": "",
                                color: "primary"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleInputValue(item)
                                }
                              },
                              model: {
                                value: _vm.params["" + item.key],
                                callback: function($$v) {
                                  _vm.$set(_vm.params, "" + item.key, $$v)
                                },
                                expression: "params[`${item.key}`]"
                              }
                            })
                          ],
                          1
                        )
                      : _c("v-text-field", {
                          attrs: {
                            label: item.name,
                            "hide-details": "",
                            "background-color": "input",
                            prefix: item.prefix || null,
                            type: item.type,
                            autofocus:
                              _vm.selectedFilters.length === 0 &&
                              item.key === "promo_name",
                            dense: "",
                            clearable:
                              item.key === "lump_sum_allowance"
                                ? _vm.params[item.key] !== true
                                : true,
                            outlined: ""
                          },
                          on: {
                            input: function($event) {
                              attrs.inputValue
                                ? null
                                : _vm.handleInputValue(item)
                            },
                            "click:clear": function($event) {
                              return _vm.removeFilter(item.key)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.search($event)
                            }
                          },
                          model: {
                            value: _vm.params["" + item.key],
                            callback: function($$v) {
                              _vm.$set(_vm.params, "" + item.key, $$v)
                            },
                            expression: "params[`${item.key}`]"
                          }
                        })
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ]),
    model: {
      value: _vm.selectedFilters,
      callback: function($$v) {
        _vm.selectedFilters = $$v
      },
      expression: "selectedFilters"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }